import { FormControl, InputLabel, MenuItem, OutlinedInput, Select } from '@mui/material'
import { useGetJobPositions } from '../../applicantsRequests'

const JobPositionFilter = ({ query, setQuery }) => {
  const { data: jobPositions = [], isLoading } = useGetJobPositions()

  return (
    <FormControl fullWidth>
      <InputLabel
        size='small'
        id='job-position-filter-label'
        sx={{
          '&.MuiInputLabel-root': {
            transform: 'translate(14px, 12px) scale(1)',
            '&.MuiInputLabel-shrink': {
              transform: 'translate(14px, -9px) scale(0.75)'
            }
          }
        }}
      >
        Job Position
      </InputLabel>
      <Select
        labelId='job-position-filter-label'
        id='job-position-filter'
        value={query.jobPosition || ''}
        size='small'
        input={<OutlinedInput label='Job Position' size='small' />}
        disabled={isLoading}
        sx={{ height: '40px' }}
        MenuProps={{
          MenuListProps: {
            sx: {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'stretch'
            }
          }
        }}
        onChange={(event) => {
          setQuery((prev) => ({ ...prev, jobPosition: event.target.value, page: 0 }))
        }}
      >
        <MenuItem value='' sx={{ width: '100%' }}>
          All job positions
        </MenuItem>
        {jobPositions.map((position) => (
          <MenuItem key={position._id} value={position._id} sx={{ width: '100%' }}>
            {position.job_title || position.translations?.al}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default JobPositionFilter
